var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"value":_vm.isOpen,"opacity":_vm.isFullyVisible ? 1 : 0,"z-index":"1000"}},[(_vm.isFullyVisible)?_c('Loading',{attrs:{"size":"50","bottomMargin":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }